export default __webpack_public_path__ + "static/media/placeholder_dummy2016-kunstshop01-de.f39863e0.png";